var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5429 39H19.4571C8.72857 39 0 30.2714 0 19.5429V19.4571C0 8.72855 8.72857 0 19.4571 0H19.5429C30.2714 0 39 8.72855 39 19.4571V19.5429C39 30.2714 30.2714 39 19.5429 39ZM19.4571 1.32011C9.45595 1.32011 1.32011 9.45593 1.32011 19.4571V19.5429C1.32011 29.544 9.45595 37.6799 19.4571 37.6799H19.5429C29.5441 37.6799 37.6799 29.544 37.6799 19.5429V19.4571C37.6799 9.45593 29.5441 1.32011 19.5429 1.32011H19.4571Z",
    fill: "url(#paint0_linear_862_3408)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.3298 8.32568H13.6706C10.4495 8.32568 7.8291 10.9461 7.8291 14.1672V24.8337C7.8291 28.0547 10.4495 30.6751 13.6706 30.6751H25.3298C28.5509 30.6751 31.1713 28.0547 31.1713 24.8337V14.1672C31.1713 10.9461 28.5509 8.32568 25.3298 8.32568ZM9.8898 14.1672C9.8898 12.0827 11.5861 10.3864 13.6706 10.3864H25.3298C27.4143 10.3864 29.1106 12.0827 29.1106 14.1672V24.8337C29.1106 26.9181 27.4143 28.6144 25.3298 28.6144H13.6706C11.5861 28.6144 9.8898 26.9181 9.8898 24.8337V14.1672Z",
    fill: "url(#paint1_linear_862_3408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5 24.9326C22.4953 24.9326 24.9335 22.4957 24.9335 19.499C24.9335 16.5024 22.4966 14.0654 19.5 14.0654C16.5033 14.0654 14.0664 16.5024 14.0664 19.499C14.0664 22.4957 16.5033 24.9326 19.5 24.9326ZM19.5 16.1275C21.36 16.1275 22.8729 17.6403 22.8729 19.5003C22.8729 21.3604 21.36 22.8732 19.5 22.8732C17.6399 22.8732 16.1271 21.3604 16.1271 19.5003C16.1271 17.6403 17.6399 16.1275 19.5 16.1275Z",
    fill: "url(#paint2_linear_862_3408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.4376 14.9437C26.2442 14.9437 26.9016 14.2875 26.9016 13.4796C26.9016 12.6717 26.2455 12.0156 25.4376 12.0156C24.6297 12.0156 23.9736 12.6717 23.9736 13.4796C23.9736 14.2875 24.6297 14.9437 25.4376 14.9437Z",
    fill: "url(#paint3_linear_862_3408)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_3408",
    x1: 19.5,
    y1: 0,
    x2: 19.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C5F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_3408",
    x1: 19.5002,
    y1: 8.32568,
    x2: 19.5002,
    y2: 30.6751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C5F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_862_3408",
    x1: 19.5,
    y1: 14.0654,
    x2: 19.5,
    y2: 24.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C5F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_862_3408",
    x1: 25.4376,
    y1: 12.0156,
    x2: 25.4376,
    y2: 14.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C5F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.cbdd1ccfb5101b3a09288ae52bf33f76.svg";
export { ForwardRef as ReactComponent };